import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import { getAuditLog, type AuditLogParams } from "src/services/auditLogService";
import { getAuditLogs, type AuditLogListParams } from "src/services/auditLogService";

type QueryOptions = { enabled?: boolean } & Record<string, unknown>;

const hasRequiredTarget = (params?: AuditLogParams) => {
  if (!params) return false;

  return (
    params.vehicle_id !== undefined && params.vehicle_id !== null && params.vehicle_id !== ""
  );
};

export const useQueryGetAuditLog = (params?: AuditLogParams, options: QueryOptions = {}) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled =
    Boolean(params?.category) && hasRequiredTarget(params) && options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.auditLogList, params, language],
      queryFn: () => getAuditLog(params as AuditLogParams, language),
      enabled,
      retry: false,
      ...options,
    }),
    enabled
  );
};

export const useQueryGetAuditLogs = (params: AuditLogListParams) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);

  return useQuery({
    queryKey: [...QueryNames.auditLogList, params, language],
    queryFn: () => getAuditLogs(params, language),
    refetchOnMount: true,
    retry: false,
  });
};
